import { render, staticRenderFns } from "./list-assets.vue?vue&type=template&id=074097e3&"
import script from "./list-assets.vue?vue&type=script&lang=ts&"
export * from "./list-assets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports